<template>
  <div class="color-picker" ref="color-picker" :class="{ disabled: disabled }">
    <span v-show="textDisplay != null" class="text-display">
        {{textDisplay}}
    </span>
    <div class="w-60 inline color-wrapper">
      <div class="color-panel">
        <div
          class="color-display"
          :style="{ 'background-color': colorValue }"
        ></div>
      </div>
    </div>

    <div class="w-40">
      <div
        @click="triggerClick"
        class="icon-combo--dropdown"
        :class="{
          disabled: disabled,
          'point-event-none': readOnly,
          expand: expanded,
        }"
      ></div>
    </div>
  </div>
  <div
    class="drop-down"
    ref="dropdown"
    :style="dropdownStyles"
    v-show="expanded"
  >
    <div class="wrapper-flex">
      <div 
        class="color-default-list"
      >
        <div
          class="color-item"
          v-for="(item, key) in defaultColorList"
          :key="key"
          :style="{ 'background-color': item }"
          @click="clickColorItem(item)"
        ></div>
      </div>

      <div class="color-pick" v-if="allowCustom">
        <input class="input-color" type="text" v-model="colorValue" />
        <div
          class="color-example"
          :style="{ 'background-color': colorValue }"
        ></div>

        <div
          class="color-setting icon24 ic-color"
          ref="setting"
          @click.self="isSetting = !isSetting"
        ></div>
      </div>
    </div>
  </div>
  <div :style="dropdownSettingStyles" ref="setting-panel">
    <color-picker
      v-model:pureColor="colorValue"
      format="hex6"
      :isWidget="true"
      v-if="isSetting"
      :disableAlpha="true"
    />
  </div>
</template>

<script >
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import { ColorPicker } from 'vue3-colorpicker';
import { ref ,toRef} from '@vue/reactivity';
import commonFn from '@/commons/commonFunction.js';
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  computed,
  nextTick,
  watch,
  onBeforeUnmount,
} from 'vue';
import 'vue3-colorpicker/style.css';

export default defineComponent({
  name: 'MsColorPicker',
  extends: msBaseComponent,
  props: {
    color: {
      type: String,
      default: null,
    },
    text:{
        type: String,
        default: null
    },
    // Có cho phép thay đổi màu sắc tự do hay không
    allowCustom:{
      type: Boolean,
      default: true
    },
    colorList:{
      type: Array,
      default: []
    }

  },
  emits: ['update:color'],
  components: {
    ColorPicker,
  },
  setup(props, { emit }) {
    const expanded = ref(false);
    const colorValue = ref(props.color);
    const heightDropUp = ref(100); // Fix vì thành phần bên trong của color picker sẽ không đổi nên không cần custom độ cao, độ dài
    const widthDropUp = ref(50);
    const isSetting = ref(false);
    const textDisplay = ref(props.text);


    // Dãy màu mặc định
    const defaultColorList = ref([
      '#ff9f00',
      '#ff3c00',
      '#19a719',
      '#007c74',
      '#0096bf',
      '#0288d1',
      '#303e9f',
      '#7b1fa2',
      '#ce4289',
      '#ff6f00',
      '#e32c2d',
      '#15831c',
      '#025a5a',
      '#00526b',
      '#00579b',
      '#1a227e',
      '#4a148c',
      '#a34075',
    ]);

    let containerWidth = 0;
    let dropdownContainer = ref();
    //  Thuộc tính dành cho drop up color pick
    let dropdownLeftx = ref();
    let dropdownWidth = ref();
    let dropdownTopx = ref();
    let dropdownMinWidthx = ref();
    let dropdownMaxWidthx = ref();
    // Thuộc tính dành cho drop up color pick của thư viện vue3-colorpicker
    let dropdownLeftxSetting = ref();
    let dropdownWidthSetting = ref();
    let dropdownTopxSetting = ref();
    let dropdownMinWidthxSetting = ref();
    let dropdownMaxWidthxSetting = ref();

    const { proxy } = getCurrentInstance();

    onMounted(() => {
      let me = proxy;
      document.addEventListener('click', me.clickOut);
    });

    onBeforeUnmount(() => {
      let me = proxy;
      document.removeEventListener('click', me.clickOut);
    });

    /**
     * Sự kiện clikc ra ngoài để ẩn color picker
     */
    function clickOut(e) {
      const me = proxy;
      if (
        me.$refs['color-picker'] &&
        !commonFn.hasParent(e.target, me.$refs['color-picker']) &&
        !commonFn.hasClass(e.target, 'color-picker') &&
        !commonFn.hasParent(e.target, me.$refs['dropdown']) &&
        !commonFn.hasClass(e.target, 'drop-down') &&
        !commonFn.hasParent(e.target, me.$refs['setting-panel'])
      ) {
        if (
          !(
            commonFn.hasClass(e.target, 'advance') ||
            commonFn.hasClass(e.target, 'back') ||
            commonFn.hasClass(e.target.childNodes[0], 'back')
          )
        ) {
          me.$nextTick(() => {
            me.expanded = false;
            me.isSetting = false;
          });
        }
      } else {
        if (
          commonFn.hasParent(e.target, me.$refs['dropdown']) &&
          !commonFn.hasClass(e.target, 'color-setting')
        ) {
          me.isSetting = false;
        }
      }
    }

    /**
     * Tính toán lại vị trí của colorpicker của thư viện vue3-colorpicker
     * tbngoc 21.06.20222
     */
    function calulateSettingPosistion() {
      let me = proxy,
        comboEl = me.$el;
      if (comboEl) {
        comboEl = me.$refs['setting'];
      }
      let gapDropUp = 8;
      let heightSetting = 330; // Fix vì lấy độ cao của popup vue3-colorpicker
      let widthSetting = 276;
      if (comboEl) {
        let comboElRect = comboEl.getBoundingClientRect(),
          comboMenuEl = me.$el;

        let windowWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

        let windowHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;

        me.dropdownLeftxSetting = comboElRect.left;

        me.dropdownMaxWidthxSetting = widthSetting
        me.dropdownTopxSetting = comboElRect.top - heightSetting - gapDropUp;
        // Nếu chạm phải thì align sang trái
        if (comboElRect.left + me.dropdownMaxWidthxSetting > windowWidth) {
          me.dropdownLeftxSetting =
            comboElRect.right - me.dropdownMaxWidthxSetting;
        }
      }
    }

    // Watch giá trị của hiển thị color picker của thư viện
    watch(
      () => isSetting.value,
      (value, oldValue) => {
        if (value == true) {
          calulateSettingPosistion();
        }
      },
      { immediate: true }
    );

    // Watch giá trị của hiển thị color picker của thư viện
    watch(
      () => colorValue.value,
      (value, oldValue) => {
        let me = proxy;
        me.$emit('update:color', value);
      },
      { immediate: true }
    );

    watch(
      () => props.color,
      (value, oldValue) => {
        colorValue.value = value;
      },
      { immediate: true }
    );

    watch(
      () => props.colorList,
      (value, oldValue) => {
        defaultColorList.value = value.length > 0? value: defaultColorList.value;
      },
      { immediate: true }
    );

    onMounted(() => {
      nextTick(() => {
        if (dropdownContainer.value) {
          containerWidth = dropdownContainer.value.clientWidth;
        }
      });
    });
    /**
     * hiển thị dropdown
     */
    function expand() {
      const me = this;

      me.$emit('beforeExpand');

      //đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = true;
      });
    }
    /**
     * click vào icon dropdown
     * tbngoc 20.06.2022
     */
    function triggerClick(e) {
      const me = this,
        expanded = me.expanded;
      //disable thì không làm gì
      if (me.disabled) {
        return;
      }

      if (!expanded) {
        // if (me.pagination) {
        //me.doQueryInternal(null, true);
        me.changeDropdownPosition();
      } else {
        me.isSetting = false;
      }

      //đặt nextick để tránh lỗi render dom của combobox tree khi chọn item từ dropdown
      me.$nextTick(() => {
        me.expanded = !expanded;
      });
    }
    /**
     * Hàm set vị trí cho dropdown menu khi expand
     * tbngoc 20.06.2022
     */
    function changeDropdownPosition() {
      let me = proxy,
        comboEl = me.$el;
      if (comboEl) {
        comboEl = me.$refs['color-picker'];
      }
      let gapDropUp = 8;

      if (comboEl) {
        let comboElRect = comboEl.getBoundingClientRect(),
          comboMenuEl = me.$el;

        let windowWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

        let windowHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;

        me.dropdownLeftx = comboElRect.left;

        me.dropdownMaxWidthx = widthDropUp.value;
        me.dropdownTopx = comboElRect.top - heightDropUp.value - gapDropUp;
        // Nếu chạm phải thì align sang trái
        if (comboElRect.left + me.dropdownMaxWidthx > windowWidth) {
          me.dropdownLeftx = comboElRect.right - me.dropdownMaxWidthx;
        }
      }
    }

    /**
     * Sự kiện chọn màu default
     * tbngoc 20.06.2022
     */
    function clickColorItem(colorCode) {
      let me = proxy;
      me.colorValue = colorCode;
    }

    /**
     * Hàm set vị trí cho dropdown khi mở color picker của thư viện
     * tbngoc 21.06.2022
     */
    function changeDropdownSettingPosition() {}

    const headerWidth = computed(() => {
      let width = 0;
      if (containerWidth) {
        width = containerWidth;
      }
      return width;
    });

    /**
     * Computed thiết lập style cho color picker
     * tbngoc 20.06.2022
     */
    const dropdownStyles = computed(() => {
      let me = proxy;
      let width = headerWidth,
        docWidth = document.body.clientWidth,
        left = me.dropdownLeftx;
      if (left + width + me.dropdownWidth > docWidth) {
        left = left - (width + left + me.dropdownWidth - docWidth);
      }

      let res = {
        top: me.dropdownTopx + 'px',
        // left: left + "px",
        minWidth: me.dropdownMinWidthx + 'px',
        height: heightDropUp.value + 'px',
        width: widthDropUp.value + 'px',
      };

      if (left + width >= docWidth) {
        res.right = '10px';
      } else {
        res.left = left + 'px';
      }
      return res;
    });

    /**
     * Computed thiết lập style cho color picker của thư viện vue3-colorpicker
     * tbngoc 21.06.2022
     */
    const dropdownSettingStyles = computed(() => {
      let me = proxy;
      let width = headerWidth,
        docWidth = document.body.clientWidth,
        left = me.dropdownLeftxSetting;
      if (left + width + me.dropdownWidth > docWidth) {
        left = left - (width + left + me.dropdownWidth - docWidth);
      }

      let res = {
        top: me.dropdownTopxSetting + 'px',
        // left: left + "px",
        minWidth: me.dropdownMinWidthxSetting + 'px',
        position: 'absolute',
      };

      if (left + width >= docWidth) {
        res.right = '10px';
      } else {
        res.left = left + 'px';
      }
      return res;
    });

    return {
      triggerClick,
      expanded,
      expand,
      colorValue,
      changeDropdownPosition,
      dropdownStyles,
      dropdownLeftx,
      dropdownWidth,
      dropdownTopx,
      dropdownMinWidthx,
      dropdownMaxWidthx,
      defaultColorList,
      clickColorItem,
      isSetting,
      dropdownSettingStyles,
      dropdownLeftxSetting,
      dropdownWidthSetting,
      dropdownTopxSetting,
      dropdownMinWidthxSetting,
      dropdownMaxWidthxSetting,
      clickOut,
      textDisplay
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsColorPicker.scss';
</style>